import AddressLookupResult from '@elements/forms/Address/AddressLookupResult';

export default function OrganizationAddresses({
  billingAddress,
  shippingAddress,
  hasBillingAddress,
  hasShippingAddress,
}) {
  return (
    <div className="container mx-auto pb-10 font-primary">
      <div className="flex flex-col text-primary-dark">
        <h2 className="font-primary text-3xl">Addressen</h2>
        <p className="mb-8 mt-1">Bekijk hier je adresgegevens</p>
      </div>
      <div className="rounded-lg bg-white px-8 pb-12 pt-5 shadow-lg">
        <div className="flex items-center justify-between pb-4 pt-2">
          <h2 className="font-primary text-xl">Factuuradres</h2>
        </div>
        <div className="flex gap-8">
          {hasBillingAddress ? (
            <div className="w-full max-w-lg divide-y divide-slate-200 rounded-lg bg-white shadow-lg">
              <AddressLookupResult
                country={billingAddress.country}
                mailLines={billingAddress?.mailLines || billingAddress?.mail_lines}
                isBillingAddress={true}
              />
            </div>
          ) : (
            <p className="pt-2 font-light">Geen adresgegevens</p>
          )}
        </div>

        <div className="flex items-center justify-between pb-4 pt-12">
          <h2 className="font-primary text-xl">Bezorgadres</h2>
        </div>
        <div className="flex gap-8">
          {hasShippingAddress ? (
            <div className="w-full max-w-lg divide-y divide-slate-200 rounded-lg bg-white shadow-lg">
              <AddressLookupResult
                country={shippingAddress.country}
                mailLines={shippingAddress?.mailLines || shippingAddress?.mail_lines}
                isBillingAddress={false}
              />
            </div>
          ) : (
            <p className="pt-2 font-light">Geen adresgegevens</p>
          )}
        </div>
      </div>
    </div>
  );
}
